/*
  Hover-to-open for the desktop mega menu.

  Dawn opens its mega menu on click, through <details>/<summary>. This adds
  hover without replacing that: setting `open` fires the native toggle event,
  which is exactly what Dawn's HeaderMenu already listens for, so its
  header-position bookkeeping still runs.

  Hover is only bound where a real pointer exists. On touch, where every
  element is "hovered" the moment it is tapped, Dawn's click behavior is left
  alone.
*/
(function () {
  'use strict';

  // Long enough to forgive a diagonal cursor path from the trigger down into
  // the panel, short enough that the menu doesn't linger.
  var CLOSE_DELAY = 140;

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var panels = Array.prototype.slice.call(nav.querySelectorAll('details'));
    if (!panels.length) return;

    var timer;

    function closeAll(except) {
      panels.forEach(function (item) {
        if (item !== except && item.open) item.open = false;
      });
    }

    panels.forEach(function (details) {
      details.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        closeAll(details);
        if (!details.open) details.open = true;
      });

      details.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.open = false;
        }, CLOSE_DELAY);
      });

      // With hover driving the panel, a mouse click on the trigger would
      // toggle it straight back shut. Suppress that for pointer clicks — and
      // where the item carries a URL, follow it instead, so a top-level entry
      // that Dawn turned into a <summary> still behaves like the link it is
      // in the menu. Picking nothing from the panel and clicking the heading
      // lands on the unfiltered collection.
      //
      // Keyboard activation reports detail === 0 and is left alone: it must
      // keep toggling, since it is the only way to open the panel without a
      // mouse. A keyboard user reaches the same destination through the
      // group headings inside the panel.
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (event.detail === 0) return;
          event.preventDefault();

          var href = summary.dataset.href;
          if (!href) return;

          // Let a modified click do what it normally would: open in a new tab
          // or window rather than navigating this one.
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            window.open(href, '_blank', 'noopener');
            return;
          }

          window.location.href = href;
        });
      }
    });

    // Tabbing out of the nav closes whatever hover left open.
    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) closeAll(null);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
